import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';
export let UfoExperiences = /*#__PURE__*/function (UfoExperiences) {
  UfoExperiences["SLACK_SEGMENT_RENDERED"] = "slack-segment-rendered";
  UfoExperiences["SLACK_REQUEST_SENT"] = "slack-request-sent";
  UfoExperiences["SLACK_FORM_ENABLED"] = "share-form-enabled";
  UfoExperiences["PLATFORM_SLACK_USERS_PAGE_FETCHED"] = "platform-slack-users-page-fetched";
  return UfoExperiences;
}({});
var PlatformComponent = /*#__PURE__*/function (PlatformComponent) {
  PlatformComponent["ShareToSlack"] = "share-to-slack";
  PlatformComponent["CoreInvites"] = "core-invites";
  return PlatformComponent;
}(PlatformComponent || {});
export const ufoExperiences = {
  [UfoExperiences.SLACK_REQUEST_SENT]: new UFOExperience(UfoExperiences.SLACK_REQUEST_SENT, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.Custom,
    platform: {
      component: PlatformComponent.ShareToSlack
    }
  }),
  [UfoExperiences.SLACK_SEGMENT_RENDERED]: new UFOExperience(UfoExperiences.SLACK_SEGMENT_RENDERED, {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
    platform: {
      component: PlatformComponent.ShareToSlack
    }
  }),
  [UfoExperiences.SLACK_FORM_ENABLED]: new UFOExperience(UfoExperiences.SLACK_FORM_ENABLED, {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.Custom,
    platform: {
      component: PlatformComponent.ShareToSlack
    }
  }),
  [UfoExperiences.PLATFORM_SLACK_USERS_PAGE_FETCHED]: new UFOExperience(UfoExperiences.PLATFORM_SLACK_USERS_PAGE_FETCHED, {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.Custom,
    platform: {
      component: PlatformComponent.CoreInvites
    }
  })
};
export const startUfoExperience = (experienceName, properties) => {
  const experience = ufoExperiences[experienceName];
  experience.start();
  if (properties) {
    experience.addMetadata(properties);
  }
};
export const succeedUfoExperience = (experienceName, properties) => {
  const experience = ufoExperiences[experienceName];
  experience.success({
    metadata: properties
  });
};
export const failUfoExperience = (experienceName, properties) => {
  const experience = ufoExperiences[experienceName];
  experience.failure({
    metadata: properties
  });
};
export const abortUfoExperience = (experienceName, properties) => {
  const experience = ufoExperiences[experienceName];
  experience.abort({
    metadata: properties
  });
};